import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import update from 'immutability-helper'
import Pagination from '../Components/Pagination'
import qs from 'qs'
import { filterClassmates, handleClassmatesDirectoryQS } from './Functions'
import { SearchForm } from './SearchForm'
import { Result } from './Result'

if (document.getElementById('usna1978_classmate_directory')) {
  const ClassmateDirectory = () => {
    const { allClassmates } = /** @type {ClassmateDirectoryDataSet} */ window.ClassmateDirectoryData
    const initialValues = qs.parse(window.location.hash.replace('#', ''))
    console.log('Initial QS Values: ', initialValues)
    const initialClassmates = filterClassmates({
      classmates: allClassmates,
      city: initialValues.city ?? '',
      company: initialValues.company ?? '',
      name: initialValues.name ?? '',
      state: initialValues.state ?? ''
    })
    const [state, setState] = useState({
      classmates: allClassmates,
      items: initialClassmates,
      name: initialValues.name ?? '',
      company: initialValues.company ?? '',
      city: initialValues.city ?? '',
      state: initialValues.state ?? '',
      page: 1,
      lastPage: Math.ceil(initialClassmates.length / 60)
    })

    const handlePageClick = (newPage) => {
      let pageLocation = '/classmates/'

      setState(update(state, { page: { $set: newPage } }))
      pageLocation += ((newPage !== 1) ? ('page/' + newPage + '/') : '')
      window.history.pushState('', 'Classmates', pageLocation)
      window.location.hash = qs.stringify(handleClassmatesDirectoryQS(state))
    }

    return (
      <div>
        <SearchForm
          state={state}
          setState={(props) => setState(props)}
        />
        <Pagination
          state={state}
          handlePageClick={(props) => handlePageClick(props)}
          includePageCount
        />
        <div className='classmates-results'>
          <div className='results-header'>
            <div className='name'>Name</div>
            <div className='company'>Company</div>
            <div className='city'>City</div>
            <div className='state'>State</div>
          </div>
          {(() => {
            const start = (state.page - 1) * 60
            let end = state.page * 60

            if (end > state.items.length) {
              end = state.items.length
            }
            console.log(state.page, start, end)

            return filterClassmates(state).slice(start, end).map((value) => <Result value={value} key={value.ID} />)
          })()}
        </div>
        <Pagination
          state={state}
          handlePageClick={(props) => handlePageClick(props)}
        />
      </div>
    )
  }

  ReactDOM.render(<ClassmateDirectory />, document.getElementById('usna1978_classmate_directory'))
}
